var UserWishlist = {
    UpdateProductWishlists: function (model, userWishlist) {
        var $userWishlist = $(userWishlist);
        var $box = $userWishlist.closest('.x-product-box, .x-product-compare-box, .wishlist-item, .cart-item, .x-product-details, .x-combo-details');

        if ($box.length < 1) return;

        var $qty = $('.js-qty, .js-quantity, .js-item-quantity, .qty-spinner-input', $box);
        var id = $box.data('productid') || $box.attr('data-parent-id'),
            skuId = $box.data('variantid') || $box.attr('data-selected-id'),
            path = $box.data('path'),
            qty = ($qty.val() ? stringToNumber($qty.val()) : null) || 1;
        var product = { id: id, skuId: skuId, path: path, qty: qty };

        //extend user wishlist model
        model = $.extend({}, model, { Product: product });
        model.IsUserWishlistsWidget = false;

        //update partial
        var html = Vendd.Handlebars.parse("userWishlists_A", model);
        $userWishlist.html(html);

        //init validation for this wishlist
        UserWishlist.InitValidation($userWishlist);

        $userWishlist.show();
    },
    ShowProductWishlists: function (userWishlist) {
        //get user wishlist model
        var model = Vendd.UserWishlist.GetClientModel();

        UserWishlist.UpdateProductWishlists(model, userWishlist);
    },
    HideAllProductWishlists: function () {
        $('.x-user-wishlists').html("").hide();
    },
    InitValidation: function (userWishlist) {
        if (userWishlistForm) userWishlistForm.destroy();

        userWishlist.validationEngine(UserWishlist.ValOpts);
        userWishlistForm = userWishlist.data('validationEngine');
    },
    ValOpts: {
        listName: { required: 'listName-required' }
    }
};

var userWishlistForm;

Vendd.Scripts.load(function () {
    'use strict';

    Vendd.MessageBus.subscribe(Vendd.Widget.Messages.BindControl, 'x-user-wishlists', function (envelope) {

        var $context = envelope.message.data.context,
            $userWishlists = $('.x-user-wishlists', $context);

        if ($userWishlists.length < 1 || !LhApp.Context.MultipleWishlistsEnabled) return;

        $userWishlists.on('click', '.js-list-select', function (e) {
            e.preventDefault();

            var $this = $(this);

            var $wishlist = $this.closest('.user-wishlist-item');
            var $box = $this.closest('.x-product-box, .x-product-compare-box, .wishlist-item, .cart-item, .x-product-details, .x-combo-details');
            var $qty = $('.js-qty, .js-quantity, .js-item-quantity, .qty-spinner-input', $box);

            var qs = LhApp.Function.QueryString.getValueOf('list');

            var id = $box.data('productid') || $box.attr('data-parent-id'),
                skuId = $box.data('variantid') || $box.attr('data-selected-id'),
                path = $box.data('path'),
                qty = ($qty.val() ? stringToNumber($qty.val()) : null) || 1,
                extraAttributes = [],
                bundleItems = [],
                listId = $wishlist.attr('data-list-id'),
                currentListId = qs ? parseInt(qs) || 0 : 0;

            Vendd.MessageBus.publishAsync($box.find('.x-user-wishlists').get(0), new Vendd.Wishlist.Messages.Add(id, skuId, path, qty, extraAttributes, bundleItems, listId, currentListId));
        });

        $userWishlists.on('click', '.js-close-user-wishlists', function (e) {
            e.preventDefault();

            UserWishlist.HideAllProductWishlists();
        });

        $userWishlists.on('keyup', 'input[name="listName"]', function (e) {
            var $userWishlist = $(this).closest('.x-user-wishlists');

            if (e.keyCode === 13) {
                e.preventDefault();
                e.stopPropagation();

                $('.js-list-create', $userWishlist).trigger('click');

                return;
            }

            userWishlistForm.validate("listName");
        });

        $userWishlists.on('click', '.js-list-create', function (e) {
            e.preventDefault();

            if (!userWishlistForm.validate()) return false;

            var $this = $(this).closest('.x-user-wishlists');
            var $input = $('input[name="listName"]', $this);

            var data = { Name: $input.val(), VisitorListId: 0 };

            Vendd.MessageBus.publishAsync($this.get(0), new Vendd.UserWishlist.Messages.SaveWishlist(data));
        });
    });

    Vendd.MessageBus.subscribe(Vendd.UserWishlist.Messages.GetModelSuccess, 'user-wishlists', function (envelope) {
        var model = envelope.message.data.model;

        if (envelope.message.data.sender) UserWishlist.UpdateProductWishlists(model, envelope.message.data.sender);
    });

    Vendd.MessageBus.subscribe(Vendd.UserWishlist.Messages.SaveWishlistFailed, 'user-wishlists', function (envelope) {
        if (envelope.message.data && envelope.message.data.message) {
            $('.js-error', envelope.sender).text(envelope.message.data.message);
            $('.js-error', envelope.sender).addClass('visible');
            setTimeout(function () { $('.js-error', envelope.sender).removeClass('visible'); }, 3000);
        }
    });

    Vendd.MessageBus.subscribe(Vendd.Wishlist.Messages.Warning, 'user-wishlists', function (envelope) {
        var response = envelope.message.data;

        //warning message
        if (response.data && response.data.ErrorMessage) {
            toastr.warning(response.data.ErrorMessage, "", { timeOut: 1500, showDuration: 600, hideDuration: 700 });
        }

        //multiple warnings
        if (response.data && response.data.Messages) {
            for (var i in response.data.Messages) {
                toastr.warning(response.data.Messages[i], "", { timeOut: 1500, showDuration: 600, hideDuration: 700 });
            }
        }

        //if requires authentication - open login widget
        if (response.code === "RequiresAuthenticationError") {
            setTimeout(function () { $(".x-login-widget .js-widget-trigger").trigger('click'); }, 500);
            setTimeout(function () { $(".x-login-widget .x-login-form input[name ='username']").focus(); }, 900);
        }
    });
});